import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";

import { toast } from "react-toastify";
import { isEmpty } from "lodash";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Nav,
  NavItem,
  NavLink,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import classnames from "classnames";
import HandleDateTimeLeft from "../../../../../../Components/Common/HandleDateTimeLeft";
import TableContainer from "../../../../../../Components/Common/TableContainer";
import NoDataContent from "../../../../../../Components/Common/NoDataContent";

import HandleDateTime from "../../../../../../Components/Common/HandleDateTime";
import {
  foodPreOrderEventGuestDelete,
  foodPreOrderEventGuestDeleteSuccess,
  foodPreOrderEventGuestInvite,
  foodPreOrderEventGuestInviteResend,
  foodPreOrderEventGuestInviteResendSuccess,
  foodPreOrderEventGuestInviteSuccess,
  foodPreOrderEventGuestList,
  foodPreOrderEventGuestSearch,
} from "../../../../../../store/foodPreOederEvent/action";
import { useParams } from "react-router-dom";
import deleteModal from "../../../../../../Components/Common/DeleteModal";
import DeleteModal from "../../../../../../Components/Common/DeleteModal";

export const GuestInvites = ({ eventUserData, EventId, asPanel }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const helperGetFoodPreOrderEventGuestList = () => {
    dispatch(
      foodPreOrderEventGuestSearch(
        [
          {
            foodpreorderevent: {
              Id: eventUserData?.data?.FoodPreOrderEvent_Id ?? EventId,
            },
          },
        ],
        params?.token ?? null
      )
    );
  };
  useEffect(() => {
    if (!EventId) return;
    helperGetFoodPreOrderEventGuestList();
  }, [eventUserData, EventId]);

  const [userInvitationEmail, setUserInvitationEmail] = useState("");

  const { foodPreOrderEventGuestInviteSUCCESS, foodPreOrderEventGuestListAPI } =
    useSelector((state) => ({
      foodPreOrderEventGuestInviteSUCCESS:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestInvite,
      foodPreOrderEventGuestListAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestList
          ?.foodpreordereventguest_list,
    }));

  const initialData = {
    FoodPreOrderEvent_Id: eventUserData?.data?.FoodPreOrderEvent_Id ?? EventId,
    ContactEmailAddress: "",
    FirstName: "",
    LastName: "",
  };
  const { foodPreOrderEventGuestSearchAPI } = useSelector((state) => ({
    foodPreOrderEventGuestSearchAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventGuestSearch
        ?.foodpreordereventguest_list,
  }));
  const [invitation, setInvitation] = useState(initialData);

  const handleSendUserInvitationEmail = () => {
    //check if first name and last name is not empty
    if (!invitation?.FirstName) {
      toast.error("Please enter a valid first name");
      return;
    }

    dispatch(foodPreOrderEventGuestInvite([invitation], params?.token ?? null));
  };

  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestInviteSUCCESS)) return;
    if (foodPreOrderEventGuestInviteSUCCESS?.status === 200) {
      toast.success(foodPreOrderEventGuestInviteSUCCESS?.message);
      helperGetFoodPreOrderEventGuestList();
      // clear form
      setInvitation(initialData);
    } else {
      toast.error(foodPreOrderEventGuestInviteSUCCESS?.message);
    }

    dispatch(foodPreOrderEventGuestInviteSuccess([]));
  }, [foodPreOrderEventGuestInviteSUCCESS]);

  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "FoodPreOrderEventGuest_FullName",
    "FoodPreOrderEventGuest_LastName",
    "FoodPreOrderEventGuest_FirstName",
    "Id",
    "FoodPreOrderEventGuest_ContactEmailAddress",
  ]);

  const columns = useMemo(
    () => [
      {
        // job id with beginning #Job_Id
        Header: " ",
        accessor: "Id",
        filterable: false,
        Cell: (item) => (
          <>
            <div className="d-flex align-items-center">
              <div
                className={"d-flex align-items-center justify-content-start"}
                style={{ width: "75px" }}
              >
                <span
                  className={
                    !item.row.original
                      ?.FoodPreOrderEventGuest_ContactEmailAddress !== "2"
                      ? "badge badge-soft-success me-1"
                      : "badge badge-soft-danger me-1"
                  }
                  title={item.row.original?.FoodPreOrderEventGuestStatus_Name}
                >
                  <i className="fa-solid fa-envelope-circle-check  fs-8 "></i>
                </span>
                {item.row.original?.FoodPreOrderEventGuestStatus_Id !== "3" && (
                  <span
                    className={
                      item.row.original?.FoodPreOrderEventGuestStatus_Id === "1"
                        ? "badge badge-soft-dark me-1"
                        : item.row.original?.FoodPreOrderEventGuestStatus_Id ===
                          "2"
                        ? "badge badge-soft-danger me-1"
                        : "badge badge-soft-success me-1"
                    }
                    title={
                      item.row.original?.FoodPreOrderEventGuestStatus_Id === "4"
                        ? "Food Selection Completed"
                        : "Food Selection Not Completed"
                    }
                  >
                    <i className="fa-solid fa-utensils fs-8"></i>
                  </span>
                )}
                <span>
                  {item.row.original?.TotalPaymentCompletedAmount && (
                    <span>
                      {+item.row.original?.TotalPaymentCompletedAmount > 0 ? (
                        <span
                          title={"Payment Received"}
                          className={"badge badge-soft-success"}
                        >
                          <i className="fa-solid fa-coins"></i>
                        </span>
                      ) : (
                        <span title={""} className={"badge badge-soft-dark"}>
                          <i className="fa-solid fa-coins"></i>
                        </span>
                      )}
                    </span>
                  )}
                </span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Name",
        accessor: "FoodPreOrderEventGuest_FullName",
        filterable: true,
        Cell: (cell) => (
          <>
            <div className={"pb-1"}>
              {cell.row.original?.FoodPreOrderEventGuest_FullName}
            </div>
            <div>
              {cell.row.original?.FoodPreOrderEventGuest_ContactEmailAddress ? (
                <span>
                  {
                    cell.row.original
                      ?.FoodPreOrderEventGuest_ContactEmailAddress
                  }
                </span>
              ) : (
                <span className={"badge badge-soft-primary"}>Manual</span>
              )}
            </div>
            {cell.row.original?.FoodPreOrderEventGuestStatus_Name && (
              <div>
                Status:{" "}
                <>{cell.row.original?.FoodPreOrderEventGuestStatus_Name}</>
              </div>
            )}
            <div>
              {cell.row.original?.FoodPreOrderEventStatus_Id === "4" ||
                (cell.row.original?.FoodPreOrderEventStatus_Id === "3" && (
                  <div>
                    <span
                      className={"badge badge-soft-info cursor-pointer"}
                      onClick={() => {
                        //   open new tab with the link current domain + /manage-event/ + token + / + event id
                        window.open(
                          `${window.location.origin}/manage-event/${cell.row.original?.MasterTokenKey_TokenKey}`,
                          "_blank"
                        );
                      }}
                    >
                      Manually Enter Meal Choices
                    </span>
                  </div>
                ))}
            </div>
            <div>
              {+cell.row.original?.TotalPaymentCompletedAmount > 0 && (
                <div>
                  <div>
                    £ {cell.row.original?.TotalPaymentCompletedAmount} paid (
                    {cell.row.original?.TotalPaymentCompletedQuantity}{" "}
                    {+cell.row.original?.TotalPaymentCompletedQuantity > 1
                      ? "payments"
                      : "payment"}
                    )
                  </div>
                </div>
              )}
            </div>
          </>
        ),
      },
      {
        Header: "Invitation Date",
        accessor: "CreatedDateTime",
        Cell: (loyalty) => {
          return (
            <>
              {loyalty.row.original?.CreatedDateTime ? (
                <div>
                  {HandleDateTime(loyalty.row.original?.CreatedDateTime)}
                </div>
              ) : (
                <div>Not Set</div>
              )}
            </>
          );
        },
        filterable: true,
      },
      {
        Header: " ",
        accessor: "AdditionalActions",
        Cell: (cellProps) => {
          return (
            <div className={"d-flex "}>
              <div>
                <button
                  title={"Remove user"}
                  className={"btn btn-danger btn-sm"}
                  onClick={() => {
                    handleRemoveUser(cellProps.row.original?.Id);
                  }}
                >
                  <div className={"d-flex align-items-center"}>
                    <i className="fa-solid fa-circle-xmark me-2 "></i>
                    <span className={"d-flex align-items-center"}>
                      Remove User
                    </span>
                  </div>
                </button>
              </div>
              {cellProps?.row.original?.MasterTokenKey_Id && (
                <div>
                  <button
                    title={"View as Guest - Opens in new tab"}
                    className={"btn btn-secondary btn-sm ms-2"}
                    onClick={() => {
                      //   open new tab with the link current domain + /manage-event/ + token + / + event id
                      window.open(
                        `${window.location.origin}/manage-event/${cellProps.row.original?.MasterTokenKey_TokenKey}`,
                        "_blank"
                      );
                    }}
                  >
                    <i className=" fa-solid fa-circle-user  me-1 "></i> View as
                    Guest
                  </button>
                </div>
              )}
            </div>
          );
        },
        filterable: false,
      },

      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-soft-info btn-icon fs-14"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-ellipsis"></i>
              </DropdownToggle>
              <DropdownMenu>
                {cellProps?.row?.original
                  ?.FoodPreOrderEventGuest_ContactEmailAddress && (
                  <DropdownItem
                    onClick={() => {
                      handleResendInvite(cellProps?.row?.original?.Id);
                    }}
                  >
                    <i className="fa-solid fa-circle-play  me-1 text-muted"></i>{" "}
                    Re-Send Invitation
                  </DropdownItem>
                )}
                {cellProps?.row.original?.MasterTokenKey_Id ? (
                  <DropdownItem
                    onClick={() => {
                      //   open new tab with the link current domain + /manage-event/ + token + / + event id
                      window.open(
                        `${window.location.origin}/manage-event/${cellProps.row.original?.MasterTokenKey_TokenKey}`,
                        "_blank"
                      );
                    }}
                  >
                    <i className="text-warning fa-solid fa-circle-user  me-1 text-muted"></i>{" "}
                    View as Guest
                  </DropdownItem>
                ) : (
                  <DropdownItem>
                    <i className="text-danger fa-solid fa-circle-user  me-1 "></i>{" "}
                    Manage Guest Unavailable
                  </DropdownItem>
                )}

                <DropdownItem
                  onClick={() => {
                    handleRemoveUser(cellProps.row.original?.Id);
                  }}
                >
                  <div className={"d-flex align-items-center"}>
                    <i className="fa-solid fa-circle-xmark align-bottom me-2 text-muted"></i>{" "}
                    Remove User
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    [searchResults]
  );

  const handleResendInvite = (id) => {
    dispatch(foodPreOrderEventGuestInviteResend({ id }, params?.token ?? null));
  };
  const { foodPreOrderEventGuestInviteResendAPI } = useSelector((state) => ({
    foodPreOrderEventGuestInviteResendAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventGuestInviteResend,
  }));
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestInviteResendAPI)) return;
    if (foodPreOrderEventGuestInviteResendAPI.status === 200) {
      toast.success(foodPreOrderEventGuestInviteResendAPI?.message);
    } else {
      toast.error(foodPreOrderEventGuestInviteResendAPI?.message);
    }
    dispatch(foodPreOrderEventGuestInviteResendSuccess([]));
  }, [foodPreOrderEventGuestInviteResendAPI]);

  const [isTypeTab, setIsTypeTab] = useState("pending");

  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestSearchAPI)) return;
    let filteredData = foodPreOrderEventGuestSearchAPI;
    const timer = setTimeout(() => {
      // check if filter is empty or not
      if (isTypeTab === "all") {
        filteredData = filteredData.filter((item) => item);
      }
      if (isTypeTab === "invited") {
        filteredData = filteredData.filter(
          (item) => item.FoodPreOrderEventGuestStatus_Id === "1"
        );
      }
      if (isTypeTab === "accepted") {
        filteredData = filteredData.filter(
          (item) => item.FoodPreOrderEventGuestStatus_Id === "2"
        );
      }
      if (isTypeTab === "declined") {
        filteredData = filteredData.filter(
          (item) => item.FoodPreOrderEventGuestStatus_Id === "3"
        );
      }
      if (isTypeTab === "confirmed") {
        filteredData = filteredData.filter(
          (item) => item.FoodPreOrderEventGuestStatus_Id === "4"
        );
      }
      filteredData = filteredData.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key]
              ?.toString()
              ?.toLowerCase()
              ?.includes(searchQuery?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredData);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery, isTypeTab, foodPreOrderEventGuestSearchAPI]);
  const [selectUserToBeRemoved, setSelectUserToBeRemoved] = useState([]);
  const handleRemoveEserFromTheInvitationList = () => {
    dispatch(
      foodPreOrderEventGuestDelete(selectUserToBeRemoved, params?.token ?? null)
    );
  };
  const [removeUserModal, setRemoveUserModal] = useState(false);

  const handleRemoveUser = (id) => {
    setSelectUserToBeRemoved([id]);
    setRemoveUserModal(true);
  };

  const { foodPreOrderEventGuestDeleteAPI } = useSelector((state) => ({
    foodPreOrderEventGuestDeleteAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventGuestDelete,
  }));

  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDeleteAPI)) return;
    if (foodPreOrderEventGuestDeleteAPI.status === 200) {
      toast.success(foodPreOrderEventGuestDeleteAPI?.message);
      helperGetFoodPreOrderEventGuestList();
      setRemoveUserModal(false);
    } else {
      toast.error(foodPreOrderEventGuestDeleteAPI?.message);
    }
    dispatch(foodPreOrderEventGuestDeleteSuccess([]));
  }, [foodPreOrderEventGuestDeleteAPI]);

  return (
    <div>
      {deleteModal && (
        <DeleteModal
          show={removeUserModal}
          onCloseClick={() => {
            setRemoveUserModal(false);
            setSelectUserToBeRemoved([]);
          }}
          onDeleteClick={() => {
            handleRemoveEserFromTheInvitationList();
          }}
          customText={
            "Are you sure you want to remove this user from the invitation list?"
          }
          customButtonText={"Yes, Remove it!"}
        />
      )}
      {!asPanel && <h3 className={"pb-2 ms-2"}>Guest Invitation</h3>}
      <div className={"pt-2 ms-2"}>
        <h5>Send Guest Invite</h5>
        <div className={"d-flex ms-2  mb-2 w-100"}>
          <div className={"d-flex flex-column   mb-2 w-100"}>
            <input
              className={"form-control send-user-invitation-email-input mt-2 "}
              type="text"
              placeholder="First Name"
              value={invitation?.FirstName}
              onChange={(e) => {
                setInvitation({
                  ...invitation,
                  FirstName: e.target.value,
                });
              }}
            />
            <input
              className={"form-control send-user-invitation-email-input mt-2"}
              type="text"
              placeholder="Last Name"
              value={invitation?.LastName}
              onChange={(e) => {
                setInvitation({
                  ...invitation,
                  LastName: e.target.value,
                });
              }}
            />
            <input
              className={"form-control send-user-invitation-email-input mt-2"}
              type="text"
              placeholder="Email"
              value={invitation?.ContactEmailAddress}
              onChange={(e) => {
                setInvitation({
                  ...invitation,
                  ContactEmailAddress: e.target.value,
                });
              }}
            />

            <div className={"d-flex flex-row w-100 mt-2"}>
              <button
                className={
                  "btn btn-success m-0 p-2 send-user-invitation-email-button "
                }
                onClick={() =>
                  handleSendUserInvitationEmail(userInvitationEmail)
                }
              >
                Send Invitation
              </button>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div>
        <Row>
          <Col lg={12}>
            <div>
              <Row className="row align-items-end mt-3">
                <Col>
                  <div id="mail-filter-navlist">
                    <Nav
                      className="nav nav-tabs nav-tabs-custom nav-primary gap-1 text-center border-bottom-0"
                      role="tablist"
                    >
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: isTypeTab === "confirmed" },
                            "fw-semibold"
                          )}
                          onClick={() => {
                            setIsTypeTab("confirmed");
                          }}
                          href="#"
                        >
                          <i className="text-success ms-1 fa-solid fa-utensils  "></i>

                          <span className="ms-1   d-sm-inline-block">
                            Confirmed
                          </span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: isTypeTab === "invited" },
                            "fw-semibold"
                          )}
                          onClick={() => {
                            setIsTypeTab("invited");
                          }}
                          href="#"
                        >
                          <i className="text-warning fa-solid fa-circle-user"></i>
                          <span className="ms-1   d-sm-inline-block">
                            Invited
                          </span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: isTypeTab === "accepted" },
                            "fw-semibold"
                          )}
                          onClick={() => {
                            setIsTypeTab("accepted");
                          }}
                          href="#"
                        >
                          <i className="text-success fa-regular fa-circle-check"></i>
                          <span className="ms-1  d-sm-inline-block">
                            Accepted
                          </span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: isTypeTab === "declined" },
                            "fw-semibold"
                          )}
                          onClick={() => {
                            setIsTypeTab("declined");
                          }}
                          href="#"
                        >
                          <i className=" text-danger fa-regular fa-circle-xmark"></i>
                          <span className="ms-1  d-sm-inline-block">
                            Declined
                          </span>
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: isTypeTab === "all" },
                            "fw-semibold"
                          )}
                          onClick={() => {
                            setIsTypeTab("all");
                          }}
                          href="#"
                        >
                          <i className="fa-solid fa-circle"></i>
                          <span className="ms-1   d-sm-inline-block">All</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </Col>
              </Row>
              <CardHeader className="border-0">
                <Row className="g-4 align-items-center">
                  <Col sm={3}>
                    <div className="search-box">
                      <Input
                        // create search with jobs List Data
                        type="search"
                        className="form-control search"
                        placeholder="Search for..."
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                        value={searchQuery}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="pt-0 w-100">
                <div>
                  {!isEmpty(searchResults) ? (
                    <TableContainer
                      columns={columns}
                      data={searchResults || []}
                      isGlobalFilter={false}
                      isAddUserList={false}
                      customPageSize={10}
                      className="custom-header-css"
                      divClass="table-responsive table-card mb-0"
                      tableClass="align-middle table-wrap"
                      theadClass="text-muted"
                      // handleLeadClick={handleLeadClicks}
                      isLeadsFilter={false}
                    />
                  ) : (
                    <>
                      <div>
                        <NoDataContent
                          titleText={`Get inviting`}
                          paragraphText={`Invite team members into your company in seconds`}
                          useButton={false}
                        />
                      </div>
                    </>
                  )}
                </div>
              </CardBody>
            </div>
          </Col>
        </Row>
      </div>

      <hr />
    </div>
  );
};
export default GuestInvites;
